/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Link } from 'react-router-dom'

const AboutComponent = () => {
  return (
    <>
<>
  <div className="inner-page-banner">
    <div className="breadcrumb-vec-btm">
      <img
        className="img-fluid"
        src="assets/images/bg/inner-banner-btm-vec.png"
        alt=""
      />
    </div>
    <div className="container">
      <div className="row justify-content-center align-items-center text-center">
        <div className="col-lg-6 align-items-center">
          <div className="banner-content">
            <h1>ABOUT US</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/"}>Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                ABOUT US
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="banner-img d-lg-block d-none">
            <div className="banner-img-bg">
              <img
                className="img-fluid"
                src="assets/images/bg/inner-banner-vec.png"
                alt=""
              />
            </div>
            <img
              className="img-fluid"
              src="assets/images/bg/inner-banner-img.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="h1-story-area two mb-120 pt-120">
    <div className="container">
      <div className="row g-lg-4 gy-5">
        <div className="col-lg-6">
          <div className="section-title1">
            <span>
              <img src="assets/images/icon/section-vec-l1.svg" alt="" />
              ABOUT US
              <img src="assets/images/icon/section-vec-r1.svg" alt="" />
            </span>
            <h2>ABOUT US</h2>
          </div>
          <div className="story-content">
            <p>
            Welcome to Pet Avenger, where our expertise in law enforcement is now dedicated to reuniting stolen pets with their owners. Our team, with over 55 years of law enforcement experience, has the solution to one of the most heartbreaking challenges pet owners face - the theft of their beloved pets.  Each year, millions of pets are stolen and less than 10% are recovered and reunited with their owners. Pet Avenger is here to change all that. We offer the expertise, the technology, and the determination to put an end to pet thefts. 
            </p>
            <p className='mt-5'>
            Imagine a world where no pet stays stolen - a world where every wagging tail finds its way back home. At Pet Avenger, this vision drives us. We understand that behind every stolen pet is a story of genuine love and family.  Act now, register your pet with Pet Avenger, because every moment counts.
            </p>
          </div>
        </div>
        <div className="col-lg-6 d-flex justify-content-lg-end justify-content-center">
          <div className="story-img">
            <img
              className="img-fluid"
              src="assets/images/bg/story-img1.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</>

    </>
  )
}

export default AboutComponent